export const BPM_PROCESS_EDITOR_PATH = "/settings-menu/bpm-process-editor";
